import { Model } from '@vuex-orm/core';
import { Scope } from './Scope';

export const OPTIONS = {
  INSCHAKELEN_AANMELDEN: 'inschakelen_aanmelden',
  INSCHAKELEN_AFMELDEN: 'inschakelen_afmelden',
  INSCHAKELEN_CONTACT: 'inschakelen_contact',
  INSCHAKELEN_INFORMEEL_TAALGEBRUIK: 'inschakelen_informeel_taalgebruik',
  INSCHAKELEN_INLOGGEN: 'inschakelen_inloggen',
  INSCHAKELEN_PROFIEL: 'inschakelen_profiel',
  INSCHAKELEN_REPETERENDE_VRAGEN: 'inschakelen_repeterende_vragen',
  ROUTERING_AANMELDING_VRAGER: 'routering_aanmelding_vrager',
  ROUTERING_AANMELDING_VRIJWILLIGER: 'routering_aanmelding_vrijwilliger',
  ROUTERING_REACTIE_PLAATSEN: 'routering_reactie_plaatsen',
  ROUTERING_VRAAG_PLAATSEN: 'routering_vraag_plaatsen',
  TONEN_AANMELDING_BEKEND_VIA: 'tonen_aanmelding_bekend_via',
  TONEN_AANMELDING_REDEN_AANMELDING: 'tonen_aanmelding_reden_aanmelding',
  TONEN_AANMELDING_VRIJVELD1: 'tonen_aanmelding_vrijveld1',
  TONEN_AANMELDING_VRIJVELD2: 'tonen_aanmelding_vrijveld2',
  TONEN_AANMELDING_VRIJVELD3: 'tonen_aanmelding_vrijveld3',
  TONEN_AANMELDING_VRIJVELD4: 'tonen_aanmelding_vrijveld4',
  TONEN_FILTER_CATEGORIE: 'tonen_filter_categorie',
  TONEN_FILTER_DIENST: 'tonen_filter_dienst',
  TONEN_FILTER_REGIO: 'tonen_filter_regio',
  TONEN_PROFIEL_VRAGER_EIGENSCHAP: 'tonen_profiel_vrager_eigenschap',
  TONEN_PROFIEL_VRAGER_ERVARING: 'tonen_profiel_vrager_ervaring',
  TONEN_PROFIEL_VRAGER_INTERESSE: 'tonen_profiel_vrager_interesse',
  TONEN_PROFIEL_VRAGER_VRIJVELD1: 'tonen_profiel_vrager_vrijveld1',
  TONEN_PROFIEL_VRAGER_VRIJVELD2: 'tonen_profiel_vrager_vrijveld2',
  TONEN_PROFIEL_VRAGER_VRIJVELD3: 'tonen_profiel_vrager_vrijveld3',
  TONEN_PROFIEL_VRAGER_VRIJVELD4: 'tonen_profiel_vrager_vrijveld4',
  TONEN_PROFIEL_VRIJVELD1: 'tonen_profiel_vrijveld1',
  TONEN_PROFIEL_VRIJVELD2: 'tonen_profiel_vrijveld2',
  TONEN_PROFIEL_VRIJVELD3: 'tonen_profiel_vrijveld3',
  TONEN_PROFIEL_VRIJVELD4: 'tonen_profiel_vrijveld4',
  TONEN_PROFIEL_VRIJWILLIGER_EIGENSCHAP: 'tonen_profiel_vrijwilliger_eigenschap',
  TONEN_PROFIEL_VRIJWILLIGER_ERVARING: 'tonen_profiel_vrijwilliger_ervaring',
  TONEN_PROFIEL_VRIJWILLIGER_INTERESSE: 'tonen_profiel_vrijwilliger_interesse',
  TONEN_PROFIEL_VRIJWILLIGER_VRIJVELD1: 'tonen_profiel_vrijwilliger_vrijveld1',
  TONEN_PROFIEL_VRIJWILLIGER_VRIJVELD2: 'tonen_profiel_vrijwilliger_vrijveld2',
  TONEN_PROFIEL_VRIJWILLIGER_VRIJVELD3: 'tonen_profiel_vrijwilliger_vrijveld3',
  TONEN_PROFIEL_VRIJWILLIGER_VRIJVELD4: 'tonen_profiel_vrijwilliger_vrijveld4',
  VERPLICHTEN_GEBOORTEDATUM: 'verplichten_geboortedatum',
  VERPLICHTEN_LOGIN: 'verplichten_login',
  VERPLICHTEN_TELEFOON_MOBIEL: 'verplichten_telefoon_mobiel',
  VERPLICHTEN_TELEFOON_VAST: 'verplichten_telefoon_vast',
  VERPLICHTEN_VRIJVELD1: 'verplichten_vrijveld1',
  VERPLICHTEN_VRIJVELD2: 'verplichten_vrijveld2',
  VERPLICHTEN_VRIJVELD3: 'verplichten_vrijveld3',
  VERPLICHTEN_VRIJVELD4: 'verplichten_vrijveld4'
};

/**
 * ORM Model
 * @see {@link https://vuex-orm.github.io/vuex-orm/guide/components/models.html}
 */
export class ScopeConfiguration extends Model {
  static entity = 'scopeConfigurations'

  static primaryKey = 'scope_key'

  static fields () {
    return {
      naam: this.attr(null),
      beschrijving: this.attr(null),
      opties: this.attr(null),
      scope_key: this.attr(null),
      scope: this.belongsTo(Scope, 'scope_key')
    };
  }
}
